import React from 'react'

const eventactivity = () => {
  return (
    <div>
      event and activity
    </div>
  )
}

export default eventactivity
